// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var BrowserComponents_Form = require("../../../shared-browser/src/components/BrowserComponents_Form.bs.js");
var BrowserComponents_Text = require("../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var BrowserComponents_Image = require("../../../shared-browser/src/components/BrowserComponents_Image.bs.js");
var BrowserComponents_Button = require("../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_FlexColumn = require("../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");

var logo = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.height(BrowserStyle.rem(4.0625)),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.height(BrowserStyle.rem(2.875)),
                tl: {
                  hd: BrowserStyle.width(BrowserStyle.rem(20.0)),
                  tl: /* [] */0
                }
              }),
          tl: {
            hd: BrowserStyle.width(BrowserStyle.rem(28.125)),
            tl: /* [] */0
          }
        }
      }
    });

function arg(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* XXLarge */6, /* Semibold */1);
}

var title = Curry._1(BrowserStyle.style, Curry._1(arg(undefined, undefined), {
          hd: BrowserStyle.alignSelf(BrowserStyle.center),
          tl: {
            hd: BrowserStyle.textAlign(BrowserStyle.center),
            tl: /* [] */0
          }
        }));

var subtitle = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.textAlign(BrowserStyle.center),
        tl: /* [] */0
      }
    });

var button = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.xxLarge),
        tl: {
          hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.xxLarge),
          tl: /* [] */0
        }
      }
    });

var Styles = {
  logo: logo,
  title: title,
  subtitle: subtitle,
  button: button
};

function WebComponents_BusinessUnauthenticatedScreen$Content(Props) {
  var buttonDisabled = Props.buttonDisabled;
  var buttonOnClick = Props.buttonOnClick;
  var buttonTitle = Props.buttonTitle;
  var buttonType = Props.buttonType;
  var children = Props.children;
  var subtitle$1 = Props.subtitle;
  var title$1 = Props.title;
  var tmp = {
    actionPriority: /* Primary */0,
    className: button,
    onClick: (function (param) {
        return buttonOnClick;
      }),
    size: /* Large */2,
    theme: /* DarkBackground */1,
    title: buttonTitle
  };
  if (buttonDisabled !== undefined) {
    tmp.disabled = Caml_option.valFromOption(buttonDisabled);
  }
  if (buttonType !== undefined) {
    tmp.type_ = Caml_option.valFromOption(buttonType);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Medium */4
                }), React.createElement(BrowserComponents_Image.make, {
                  className: logo,
                  image: {
                    TAG: /* Logo */2,
                    _0: /* BusinessLight */2
                  }
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XXLarge */7
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* Small */3
                }), React.createElement(BrowserComponents_Text.make, {
                  className: title,
                  children: title$1
                }), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XLarge */6
                }), Relude_Option.fold(null, (function (subtitle$2) {
                    return React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Text.make, {
                                    className: subtitle,
                                    children: subtitle$2
                                  }), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Large */5
                                  }));
                  }), subtitle$1), children, React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XLarge */6
                }), React.createElement(BrowserComponents_Button.make, tmp));
}

var Content = {
  Styles: Styles,
  make: WebComponents_BusinessUnauthenticatedScreen$Content
};

var wrapper = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.backgroundImage(BrowserStyle.url(BrowserStyle.$$Image.heroBusiness)),
      tl: {
        hd: BrowserStyle.backgroundPosition("center"),
        tl: {
          hd: BrowserStyle.backgroundRepeat("noRepeat"),
          tl: {
            hd: BrowserStyle.backgroundSize("cover"),
            tl: {
              hd: BrowserStyle.display("flex"),
              tl: {
                hd: BrowserStyle.flex({
                      NAME: "num",
                      VAL: 1.0
                    }),
                tl: {
                  hd: BrowserStyle.flexDirection(BrowserStyle.row),
                  tl: {
                    hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
                    tl: {
                      hd: BrowserStyle.minHeight(BrowserStyle.vh(100.0)),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var content = Curry._1(BrowserStyle.style, {
      hd: Css.backgroundColor(BrowserStyle.Color.tToRgba(0.9)({
                TAG: /* Grey */2,
                _0: /* Darkest */0
              })),
      tl: {
        hd: BrowserStyle.boxSizing(BrowserStyle.borderBox),
        tl: {
          hd: BrowserStyle.color({
                TAG: /* White */7,
                _0: /* Light */2
              }),
          tl: {
            hd: BrowserStyle.flex({
                  NAME: "num",
                  VAL: 1.0
                }),
            tl: {
              hd: BrowserStyle.flexBasis(BrowserStyle.pct(40.0)),
              tl: {
                hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
                tl: {
                  hd: BrowserStyle.minWidth(BrowserStyle.rem(34.0)),
                  tl: {
                    hd: BrowserStyle.mobileMedia({
                          hd: BrowserStyle.flexBasis(BrowserStyle.pct(100.0)),
                          tl: {
                            hd: BrowserStyle.minWidth(BrowserStyle.zero),
                            tl: {
                              hd: BrowserStyle.padding(BrowserStyle.Spacing.medium),
                              tl: /* [] */0
                            }
                          }
                        }),
                    tl: {
                      hd: BrowserStyle.padding(BrowserStyle.Spacing.xxLarge),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }
      }
    });

var emptyContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 2.0
          }),
      tl: {
        hd: BrowserStyle.flexBasis(BrowserStyle.pct(60.0)),
        tl: /* [] */0
      }
    });

var Styles$1 = {
  wrapper: wrapper,
  content: content,
  emptyContainer: emptyContainer
};

function WebComponents_BusinessUnauthenticatedScreen$Container(Props) {
  var children = Props.children;
  var layout = Props.layout;
  return React.createElement("main", {
              className: wrapper
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  className: content,
                  children: children
                }), layout >= 2 ? React.createElement("div", {
                    className: emptyContainer
                  }) : null);
}

var Container = {
  Styles: Styles$1,
  make: WebComponents_BusinessUnauthenticatedScreen$Container
};

var form = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.display("flex"),
      tl: {
        hd: BrowserStyle.flexDirection(BrowserStyle.column),
        tl: {
          hd: BrowserStyle.flexWrap(BrowserStyle.nowrap),
          tl: /* [] */0
        }
      }
    });

var Styles$2 = {
  form: form
};

function WebComponents_BusinessUnauthenticatedScreen$Form(Props) {
  var buttonDisabled = Props.buttonDisabled;
  var buttonTitle = Props.buttonTitle;
  var children = Props.children;
  var layout = Props.layout;
  var onSubmit = Props.onSubmit;
  var subtitle = Props.subtitle;
  var title = Props.title;
  var tmp = {
    buttonOnClick: Relude_IO.pure(undefined),
    buttonTitle: buttonTitle,
    buttonType: "submit",
    children: children,
    title: title
  };
  if (buttonDisabled !== undefined) {
    tmp.buttonDisabled = Caml_option.valFromOption(buttonDisabled);
  }
  if (subtitle !== undefined) {
    tmp.subtitle = Caml_option.valFromOption(subtitle);
  }
  return React.createElement(WebComponents_BusinessUnauthenticatedScreen$Container, {
              children: React.createElement(BrowserComponents_Form.make, {
                    className: form,
                    onSubmit: onSubmit,
                    children: React.createElement(WebComponents_BusinessUnauthenticatedScreen$Content, tmp)
                  }),
              layout: layout
            });
}

var Form = {
  Styles: Styles$2,
  make: WebComponents_BusinessUnauthenticatedScreen$Form
};

function WebComponents_BusinessUnauthenticatedScreen(Props) {
  var buttonDisabled = Props.buttonDisabled;
  var buttonOnClick = Props.buttonOnClick;
  var buttonTitle = Props.buttonTitle;
  var buttonType = Props.buttonType;
  var children = Props.children;
  var layout = Props.layout;
  var subtitle = Props.subtitle;
  var title = Props.title;
  var tmp = {
    buttonOnClick: buttonOnClick,
    buttonTitle: buttonTitle,
    children: children,
    title: title
  };
  if (buttonDisabled !== undefined) {
    tmp.buttonDisabled = Caml_option.valFromOption(buttonDisabled);
  }
  if (buttonType !== undefined) {
    tmp.buttonType = Caml_option.valFromOption(buttonType);
  }
  if (subtitle !== undefined) {
    tmp.subtitle = Caml_option.valFromOption(subtitle);
  }
  return React.createElement(WebComponents_BusinessUnauthenticatedScreen$Container, {
              children: React.createElement(BrowserComponents_FlexColumn.make, {
                    children: React.createElement(WebComponents_BusinessUnauthenticatedScreen$Content, tmp)
                  }),
              layout: layout
            });
}

var make = WebComponents_BusinessUnauthenticatedScreen;

exports.Content = Content;
exports.Container = Container;
exports.Form = Form;
exports.make = make;
/* logo Not a pure module */
